module.exports = __webpack_public_path__ + "images/607d38d5fcd658d07ca843c3a59adc8b.png";